import classNames from 'classnames';
import { useMemo, useState } from 'react';

import type { Recommendation } from '@/types';
import { EmailModal } from './EmailModal';

interface SubscribeButtonProps {
  recommendation: Recommendation;
  isLoading?: boolean;
  email?: string;
  submittedIds: string[];
  translations?: Record<string, string>;
}

export const SubscribeButton: React.FC<SubscribeButtonProps> = ({
  email,
  recommendation,
  submittedIds,
  isLoading,
  translations,
}) => {
  const hasSubscribed = useMemo(() => submittedIds.includes(recommendation.id), [submittedIds, recommendation.id]);
  const [emailCaptureOpen, setEmailCaptureOpen] = useState(false);

  return (
    <div className="relative">
      <button
        type={email ? 'submit' : 'button'}
        onClick={(e) => {
          if (!email) {
            e.preventDefault();
            setEmailCaptureOpen(true);
          }
        }}
        className={classNames(
          'px-2 py-1 rounded-[--site-theme-border-radius] bg-[--site-theme-background-color] text-[--site-theme-primary-color] border border-[--site-theme-primary-color] font-medium flex gap-2 items-center',
          hasSubscribed ? 'opacity-30 cursor-not-allowed' : 'hover:opacity-80',
          isLoading && 'cursor-wait',
        )}
        style={{ fontFamily: 'var(--site-theme-button-font)' }}
        disabled={hasSubscribed || isLoading}
      >
        {hasSubscribed
          ? translations?.['recommendations.modal.subscribed'] || 'Subscribed'
          : isLoading
            ? translations?.['recommendations.modal.subscribing'] || 'Subscribing...'
            : translations?.['recommendations.modal.subscribe'] || 'Subscribe'}
      </button>
      <EmailModal
        isOpen={emailCaptureOpen}
        onClose={() => setEmailCaptureOpen(false)}
        className="w-72 -top-3 -right-2"
      />
    </div>
  );
};
